import React from 'react';
import { Card, CardContent } from '@/components/ui/card';

interface ProblemSectionProps {
  cityName: string;
  title?: string;
  paragraphs: string[];
}

export function ProblemSection({ cityName, title, paragraphs }: ProblemSectionProps) {
  return (
    <section id="problem" className="py-12 sm:py-16 md:py-20">
      <div className="container px-4 sm:px-6">
        <div className="max-w-4xl mx-auto animate-fade-in-up">
          <Card className="border-2 border-destructive/20 bg-destructive/5 hover:border-destructive/30 transition-all duration-300">
            <CardContent className="p-6 sm:p-8 md:p-12">
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 sm:mb-6 text-center px-2">
                {title || 'Tired of Feeling Unheard?'}
              </h2>
              <div className="space-y-3 sm:space-y-4 text-base sm:text-lg text-muted-foreground leading-relaxed">
                {paragraphs.map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
}
